import { useContext } from 'react';
import AdUnit from '../../AdUnit';
import { useBreakpoint } from '@buzzfeed/react-components';
import ABeagleContext from '../../../../contexts/abeagle';
import { isGeneratorPage } from '../../../../utils/isGeneratorPage';
import { getUserGeoCountry } from '@buzzfeed/bf-utils/lib/localization';
import { isGamesPost } from '../../../../utils/games';

function InterstitialAdUnit({buzz}) {
  const { getFeatureFlagValue } = useContext(ABeagleContext);
  const isMobile = useBreakpoint('(max-width:500px)'); // page level break is based on bf_header_ui break
  const isEligible = getUserGeoCountry().toLowerCase() === 'us'
    && isMobile
    && !(buzz.isQuiz || buzz.isShopping || isGeneratorPage(buzz) || isGamesPost(buzz));

  const isOn = getFeatureFlagValue('ads_interstitial');

  return (
    isEligible && isOn && <AdUnit type="interstitial" />
  );
}
export default InterstitialAdUnit;
